import { enumMatchSubs, enumObjClassNames } from "../constants";
import { StringToBool } from "../utils/StringToBool";
import { enumRuleType, QRule } from "./QRule";
import { QXMLObject } from "./QXMLObject";
import { enumRulePairLogicCondition } from "./QRulePair";

export class QHighlight extends QXMLObject {
  constructor() {
    super();
    this.fName = null;
    this.fDef = null;
    this.fActive = null;
    this.fColor = null;
    this.fHidden = false;
    this.fHighlightOnByDefault = false;

    this.fChartID = null;
    this.fUID = null;
    this.fGroupIdentifier = null;
  }

  DoInitHighlight() {
    this.SetXMLElementName("highlight");
  }

  // AUG26
  InitHighlight(name, rule, active, color, isBasicRule = false) {
    this.fName = name;
    if (isBasicRule) {
      rule.SetRuleCriteria(enumRuleType.basic);
      this.fDef = rule;
    } else {
      var theRule = new QRule();
      theRule.InitRule(Boolean(enumMatchSubs.matchonly), 0, false);
      theRule.SetIsComplex(true);
      theRule.SetComplexDef(rule);
      this.fDef = theRule;
    }
    this.fActive = active;
    this.fColor = color;
    this.DoInitHighlight();
  }

  OutputToJSON() {
    var hObj = {};
    hObj["name"] = this.fName;
    hObj["def"] = this.fDef?.OutputToJSON();
    hObj["active"] = this.fActive;
    hObj["color"] = this.fColor;
    hObj["groupIdentifier"] = this.fGroupIdentifier;
    hObj["chartID"] = this.fChartID;
    hObj["UID"] = this.fUID;

    return hObj;
  }

  LoadFromJSON(json) {
    this.fName = json["name"];
    let def = new QRule();

    this.fDef = def.LoadFromJSON(json["def"]);
    this.fDef?.EnsureRulesUIDs();
    this.fActive = json["active"] ?? json["enabled"];
    this.fColor = json["color"];
    this.fGroupIdentifier = json["groupIdentifier"];
    this.fUID = json["UID"];
    this.fChartID = json["chartID"];
  }

  LoadFromLocalStorageObject(obj, hl) {
    this.fName = obj.name;

    const newRule = new QRule();
    newRule.InitRule(false, 0, false);

    hl[1].forEach(val => {
      const rule = newRule.AddRulePair(hl[0], hl[0], enumObjClassNames.box, "equals", val);
      rule.fCondition = enumRulePairLogicCondition.or;
    });

    newRule.SetRuleCriteria(enumRuleType.basic);
    newRule.EnsureRulesUIDs();

    this.fDef = newRule;
    this.fColor = hl[2];
    this.fActive = obj.enabled;
    this.fGroupIdentifier = obj.id;
    this.fChartID = obj.chartID;
    this.fUID = obj.filterID;
  }

  OutputSubElements(stream) {
    this.OutputSimpleElement("hname", this.fName, stream);
    var outputDef = this.fDef;
    this.OutputSimpleElement(
      "hdef",
      outputDef?.fComplexDef != null ? outputDef.fComplexDef : outputDef,
      stream
    );
    this.OutputSimpleElement("hactive", this.fActive, stream);
    this.OutputSimpleElement("hcolor", this.fColor, stream);
  }

  LoadSubElements(objTree) {
    this.fName = objTree.GetValueForChild("hname", false);

    let rule = new QRule();
    rule.InitRule(false, 0, false);
    this.fDef = rule;
    rule.SetIsComplex(true);
    rule.SetComplexDef(objTree.GetValueForChild("hdef", false));
    this.fColor = objTree.GetValueForChild("hcolor", false);
    var highlightOff = objTree.GetValueForChild("hactive", false);
    this.fActive = StringToBool(highlightOff);
  }

  GetFilterApplied() {
    return this.fActive;
  }

  SetFilterApplied(filterOn) {
    this.fActive = filterOn;
  }

  GetHighlightApplied() {
    return this.fActive;
  }

  SetHighlightApplied(filterOn) {
    this.fActive = filterOn;
  }

  GetHighlightRule() {
    return this.fDef;
  }

  GetHighlightColor() {
    return this.fColor;
  }

  GetName() {
    return this.fName;
  }

  SetName(name) {
    this.fName = name;
  }

  SetHighlightColor(color) {
    this.fColor = color;
  }

  SetChartID(id) {
    this.fChartID = id;
  }

  GetChartID() {
    return this.fChartID;
  }

  SetUID(id) {
    this.fUID = id;
  }

  GetUID() {
    return this.fUID;
  }

  SetGroupIdentifier(id) {
    this.fGroupIdentifier = id;
  }

  GetGroupIdentifier() {
    return this.fGroupIdentifier;
  }

  Clone() {
    var cFilter = new QHighlight();
    cFilter.fActive = this.fActive;
    cFilter.fName = this.fName;
    cFilter.fDef = this.fDef?.Clone() ?? null;
    cFilter.fColor = this.fColor;
    cFilter.fChartID = this.fChartID;
    cFilter.fUID = this.fUID;
    cFilter.fGroupIdentifier = this.fGroupIdentifier;
    return cFilter;
  }
}
